import React from 'react'
import styles from './styles.module.css'
import dayjs from '@helpers/dayjs'
import {useTranslation} from 'next-i18next'
import isStoreOpenNow from '@helpers/websites/isStoreOpenNow'
import isObject from 'lodash/isObject'

export default function NextOpenDate(props) {
  const {t} = useTranslation('website', {keyPrefix: 'order.nextOpenDate'})
  if (!props.store) return null

  const propsItsOpenNow = props.store.schedule && props.store.schedule.itsOpenNow
  const itsOpenNow = isStoreOpenNow(props.store)
  const closedMessage =
    !!propsItsOpenNow && (isObject(propsItsOpenNow) as any) ? propsItsOpenNow.closedMessage : null
  if (itsOpenNow) return null

  const nextDate = props.store.nextAvailableDate
  const schedulingOrdersDays = props.store.schedulingOrdersDays

  const className = [styles.container, props.className].join(' ')
  const schedulingClassName = [styles.scheduling, props.className].join(' ')

  if (closedMessage) {
    return <div className={schedulingClassName}>{closedMessage}</div>
  }

  if (!nextDate) {
    return <div className={className}>{t('labelClosedNow')}</div>
  }

  const date = dayjs(nextDate)

  if (date.isSame(dayjs(), 'day')) {
    if (schedulingOrdersDays) {
      return (
        <div className={schedulingClassName}>
          {t('labelScheduleOrderAfter', {date: date.format('HH:mm')})}
        </div>
      )
    }

    return <div className={className}>{t('labelClosedUntil', {date: date.format('HH:mm')})}</div>
  }

  if (date.isSame(dayjs().add(1, 'day'), 'day')) {
    if (schedulingOrdersDays >= 2) {
      return <div className={schedulingClassName}>{t('labelScheduleOrderTomorrow')}</div>
    }

    return (
      <div className={className}>{t('labelClosedUntilTomorrow', {date: date.format('HH:mm')})}</div>
    )
  }

  if (schedulingOrdersDays >= 3) {
    return (
      <div className={schedulingClassName}>
        {t('labelScheduleOrderFrom', {date: date.format('dddd D [de] MMMM')})}
      </div>
    )
  }

  return (
    <div className={className}>
      {t('labelClosedUntilDate', {
        date: date.format('LL'),
        hour: date.format('HH:mm')
      })}
    </div>
  )
}
